<template>
    <div>
        <h2 class="post__title text-center bold">第三篇： 如何扩展孩子的专注力 - 满足孩子的感官需求是关键</h2>
        <h3 class="post__meta text-center">by <router-link class="post__author"
          :to="`/home/team`">{{ author }}</router-link>
           	- <time>{{ prettyDate(published) }}</time>
        </h3>
        <h2 class="post__title text-left bold-underlined">志愿者家长S提到：</h2>
        <section class="post__body rte">“我有一次参加孩子幼儿园组织的去参观工厂的活动，我注意到他在活动讲解员讲话的时候没有认真去听，整个15分钟的讲话他自己在那里玩儿。但我也同时注意到，讲解员和孩子们的互动不多，内容也比较枯燥，有三分之二的孩子们像我儿子一样没有在认真听讲。我担心他上小学以后也不专心，学习跟不上。”</section>
        
        <h2 class="post__title text-left bold-underlined">我对这个问题的解释是：</h2>
        <section class="post__body rte">孩子不是有意的在开小差。是因为当时的环境没有足够地支持孩子的感官需求，孩子不自觉地在寻求感官上的刺激。</section>

      <h2 class="post__title text-left bold-underlined">人有五大感官</h2>
      <ul class="list-with-bullets">
          <li class="post__body3 rte">视觉 Sight</li>
          <li class="post__body3 rte">听觉 Hearing</li>
          <li class="post__body3 rte">味觉 Taste</li>
          <li class="post__body3 rte">嗅觉 Smell</li>
          <li class="post__body3 rte">触觉 Touch</li>
      </ul>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3A.jpg" alt="image"/>
        <section class="mx-auto d-block topbit"><a href="https://images.app.goo.gl/9XFuPo4MReJGnDTAA">https://images.app.goo.gl/9XFuPo4MReJGnDTAA</a></section>
        </div>
      </div>

      <h2 class="post__title text-left bold-underlined">寻求感官刺激 （Sensory Seeking）- 孩子开小差不是他的错</h2>
      <section class="post__body rte">当我们的五大感官达到平衡满足的时候，我们会不自觉的去寻求某种感官上的刺激，以此来达到平衡。孩子也是一样的。正像S妈妈说的，活动讲解员和孩子们的互动不多，内容也比较枯燥。在这种环境里，孩子的感官需求没有得到足够的满足。发言人只在讲话，仅仅通过听觉来交流，没有考虑到其他的感官交流方式来吸引孩子们的好奇心和注意力，实在是太单一枯燥了。孩子在其他感官没有得到满足的情况下，自己开始玩，是一种不自觉的去寻求感官上的刺激，实在不是有意捣乱和不听话。这是典型的学习环境没有满足我们孩子的需求，而不是孩子的错。</section>

        <h2 class="post__title text-left bold-underlined">如何通过满足感官需求来提高专注力？</h2>
        <section class="post__body3 rte"><span class="bold">大人的例子：</span> 我们在做书面工作的时候喜欢放音乐就是一个典型的寻求感官刺激的例子。书面工作一般比较枯燥，我们不自觉的选择通过满足听觉来让自己集中精力。</section>

        <section class="post__body3 rte"><span class="bold">那我们如何帮助孩子呢？</span> 比如，在上网课或听讲座的时候，情况允许下给孩子一些橡皮泥或小绒球来满足触感，提高孩子的专注力。作为一个成年人，我自己也时常用这个方法撑过了很多漫长的会议。</section>

        <section class="post__body rte">再回到S妈妈提到的例子。讲解员有很多种选择来提高孩子的兴趣和专注力：1）可以通过展示视频或图片，从视觉上吸引孩子；2）让孩子触摸工厂机器的小模型或零件，从触觉上让孩子体验学习；3） 让孩子尝试闻一下机油的味道，从嗅觉上让孩子体验在工厂工作的经历。</section>

       <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3B.jpg" alt="image"/>
        <section class="mx-auto d-block topbit">Photo by Ketut Subiyanto from Pexels</section>
        </div>
      </div>

      <h2 class="post__title text-left bold-underlined">相反的情况： 感官刺激超负荷 (Sensory Overload) - 孩子发脾气，逃避或发呆不是他的错</h2>

      <section class="post__body rte">感官输入不足就是前文例子中的结果，输入过多就会产生感官刺激超出负荷。比如商场或学校的大型活动是一些孩子不能承受的地方，因为那里喧闹拥挤，各种灯光闪烁，还有气味浓郁。由于每个人的承受能力不同，有些感官敏感的孩子在这种环境里会超出负荷。在这种压力下，他们会不自觉地选择逃避或发呆来缓解自己超压的状态，或者用发脾气来释放他们的紧张(sensory meltdown)。在这个过程中，很多孩子被误解为脾气差不讲道理，或偷懒不积极。如果你的孩子有这些表现，请切记这并不代表你的孩子不正常，只说明他在这一方面比较敏感，需要一些事前准备，以及过程中一些帮助和引导。</section>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3C.jpeg" alt="image"/>
        <section class="mx-auto d-block topbit">图片来源：</section>
        <section class="post__body1 rte"><a href="https://www.facebook.com/thecontentedchild/photos/a.529308263884213/1634924903322538/">https://www.facebook.com/thecontentedchild/photos/a.529308263884213/1634924903322538/</a></section>
        </div>
      </div>

      <h2 class="post__title text-left bold-underlined">孩子容易感官刺激超负荷怎么办？</h2>
      <section class="post__body3 rte"><span class="bold">事前和孩子一起商讨制定短暂的休息时间：</span> 事前准备比事后灭火要好很多，孩子不用受罪，家长不用焦虑。与孩子一起计划是一个提高参与性和学习交流的好机会。一件困难枯燥的任务我们不能逃避，但我们可以一起计划怎么度过难关。比如，每做15分钟的题，就可以听5分钟的轻松音乐 （听觉），玩沙或橡皮泥 （触觉），或喝水吃小点心 （味觉）。从满足各种感官上来计划休息时间的内容。</section>
      <section class="post__body3 rte"><span class="bold">过程之中给孩子一个短暂的喘息机会：</span> 这是在教孩子学会如何自我调节，而不是教他偷懒，因为喘息之后还需要继续完成任务。我们可以限制时间，比如给孩子10分钟到一个安静的地方喝口水，做一下深呼吸，以及肢体伸展。</section>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3D.png" alt="image"/>
        <section class="mx-auto d-block topbit">图片来源：</section>
        <section class="post__body1 rte"><a href="https://www.facebook.com/thecontentedchild/photos/a.529308263884213/1634924903322538/">https://www.facebook.com/thecontentedchild/photos/a.529308263884213/1634924903322538/</a></section>
        </div>
      </div>

    <h2 class="post__title text-left bold-underlined">感官刺激负荷怎么办? - 阅读推荐</h2>
      <section class="post__body1 rte"><a href="https://autismawarenesscentre.com/shop/children-s-books/why-does-izzy-cover-her-ears-dealing-with-sensory-overload/">https://autismawarenesscentre.com/shop/children-s-books/why-does-izzy-cover-her-ears-dealing-with-sensory-overload/</a></section>
      <section class="post__body1 rte"><a href="https://www.thechaosandtheclutter.com/archives/sensory-overload-meltdown">https://www.thechaosandtheclutter.com/archives/sensory-overload-meltdown</a></section>
      <section class="post__body1 rte"><a href="https://reflectionsofabear.com/2015/09/14/warning-warning-sensory-overload/">https://reflectionsofabear.com/2015/09/14/warning-warning-sensory-overload/</a></section>

       <h2 class="post__title text-left bold-underlined">调节满足孩子的感官需求的重要性</h2>

      <section class="post__body rte">孩子的感官需求是一种生理需求，也是学习能力，专注力，情绪调节能力，社交能力，日常行为等各方面能力的基础，很多时候却被忽略了。但成人对孩子的要求却是此基础之上的结果。所以我们在要求孩子各种能力表现的时候，可以稍微想一下，孩子的基本需求是否得到满足，这个环境是否适合孩子目前尚未成熟的能力。</section>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3E.jpeg" alt="image"/>
        <section class="mx-auto d-block topbit">图片来源：</section>
        <section class="post__body1 rte"><a href="https://images.app.goo.gl/ygvkhf2vNWBKNvWG6">https://images.app.goo.gl/ygvkhf2vNWBKNvWG6</a></section>
        </div>
      </div>
      
      <h2 class="post__title text-left bold-underlined">如何加强孩子的感官承受能力</h2>
      <section class="post__body rte">平时做一些有趣的感官活动(sensory activities)，保持孩子各种感官之间的平衡，这样孩子的承受能力也会加强。比如：</section>

      <ul class="list-with-bullets">
          <li class="post__body3 rte">Sensory box &amp; messy play 感官游戏体验盒子；提供不同触感材料不设章法的自由玩法</li>
          <li class="post__body3 rte">Baking &amp; cooking with adults 和家长一起烘培和做饭就是感官体验的一种</li>
          <li class="post__body3 rte">Physical activities such as trampoline or biking 体育活动：比如蹦床或骑自行车，练习平衡力有助于大脑发育。</li>
          <li class="post__body3 rte">Exploring nature - collecting leaves during a bush walk, or collecting shells during a beach walk. 与大自然近距离：去树林里收集有趣的叶子，去海边收集好看的贝壳。</li>
      </ul>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article3F.jpg" alt="image"/>
        <section class="mx-auto d-block topbit">Photo by Tatiana Syrikova from Pexels</section>        
        </div>
      </div>

      <router-link @click.native="scrollToTop" :to="`zoom-attention-span-part4`"><h2 class="post__title text-left bold-underlined">下篇预告：观众问题回答 （请点击）</h2></router-link>
      <router-link @click.native="scrollToTop" :to="`zoom-attention-span-part2`"><h2 class="post__title text-left bold-underlined">第二篇：如何扩展孩子的专注力 - 给予情感和行为上的支持（请点击）</h2></router-link>
      <router-link @click.native="scrollToTop" :to="`zoom-attention-span-part1`"><h2 class="post__title text-left bold-underlined">第一篇：咨询前期，心理师为什么要问一堆不着边际的问题？（请点击）</h2></router-link>
      
        <div class="row mx-auto col-md-6">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/yi_2021.jpg" alt="image"/>
        </div>
        <div class="col-md-6">
          <section class="post__body rte">张艺 – 新西兰注册心理师</section>
          <section class="post__body rte">New Zealand Registered Psychologist</section>
          <section class="post__body rte"><a href="https://www.reachingpotential.co.nz">reachingpotential.co.nz</a></section>
            <img class="col-md-5" src="@/assets/images/yi_weechat.jpg" alt="image"/>
            <section class="post__body rte">微信号：YZNZ2013</section>
        </div>
      </div>
    </div>
</template>

<script>
import { kebabify, prettyDate } from '../helpers'
export default
{
  data() {
    return {
      author: 'Yi Zhang',
      published: '2021-03-13T18:17:00Z'
    }
  },
    methods: {
        kebabify,
        prettyDate,
        scrollToTop() {
          window.scrollTo(0,0);
        }
    }
}
</script>

<style>
@media (min-width: 768px ) {
  .row {
      position: relative;
      padding: 1.25rem 1.25rem 1rem;
  }

  .bottom-align-text {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.list-with-bullets li::before {
  /* padding: 0.25rem 1.25rem 0rem; */
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */ 
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: 0em; /* Also needed for space (tweak if needed) */
}

.topbit {
  padding-top: 0.5rem;
}

.bottombit {
  padding-bottom: 0.5rem;
}

.imagestyle2
{
  width: 8em;
}

.highlight
{
  background-color: yellow;
  font-size: 23px;
}

.bold-underlined {
  font-weight: bold;
  text-decoration: underline;
  padding: 1rem;
}

.bold {
  font-weight: bold;
}
</style>
